import { AnalyticsMetaKeys as key } from '../../../../../../services/analytics/formatters/meta-keys'
import { AnalyticsEvent } from '../../../../event'
import { AttributeFormatter } from '../../formatters/attribute'
import { ViafouraAttrFormatter } from '../../formatters/viafoura'
import { PageEvents } from '../../page-events'

const mParticleEvents: any = new PageEvents()

export class ViafouraEvents extends AnalyticsEvent {

    public attributeFormatter = new AttributeFormatter()
    public viafouraAttrFormatter = new ViafouraAttrFormatter()
    /**
     * Handle viafoura event
     */
    public handle(): void {

        let eventName = ''
        const attrs = [
            key.TITLE, key.ARTICLE_ID,
            key.ORIGINAL_ID, key.DOMAIN
        ]

        switch(this.type) {
            case 'comment-disliked':
                eventName = PageEvents.mpEventName.ViafouraDislike
                attrs.push(
                    key.VIA_DISLK_RCVD,
                    key.VIA_DISLK_MADE
                )
                break
            case 'comment-liked':
                eventName = PageEvents.mpEventName.ViafouraLike
                attrs.push(
                    key.VIA_LIKE_MADE,
                    key.VIA_LIKE_RCVD
                )
                break
            case 'user-comment':
                eventName = PageEvents.mpEventName.ViafouraComment
                attrs.push(
                    key.VIA_TOTAL_CMNTS,
                    key.VIA_DATE_CRETED,
                    key.VIA_TOTAL_CMNTS_MADE,
                    key.VIA_TOTAL_CMNTS_RCVD,
                    key.VIA_RNK_CMNTS_MADE,
                    key.VIA_RNK_CMNTS_RCVD,
                    key.VIA_RNK_CMNTS_OVRAL,
                    key.VIA_RNK_SUB_CNT,
                    key.VIA_CMNTS_RTNG,
                    key.VIA_CMNTS_LVL,
                    key.VIA_CMNTS_TYP
                )
                break
            case 'user-updated':
                eventName = PageEvents.mpEventName.ViafouraUserUpdate
                attrs.push(
                    key.VIA_SCL_LGIN_ID,
                    key.VIA_SCL_LGIN_PRDR,
                    key.VIA_USR_PRVLG,
                    key.VIA_RNK_CMNTS_RCVD
                )
                break
        }

        const data = this.attributeFormatter.format(
            attrs, {
                ...this.metaProperties,
                ...this.viafouraAttrFormatter.format(this.value || {})
            }
        )

        mParticleEvents.logEvent(
            eventName,
            PageEvents.mpEventType.UserPreference,
            data
        )
    }

}
